import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const naviMumbai: AreaConfig = {
  name: 'Navi Mumbai',
  slug: 'navi-mumbai',
  tagline: 'Doorstep Mobile Repair in Navi Mumbai',
  description:
    "Navi Mumbai's planned city gets planned mobile repair — at your doorstep. minto covers Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, and more. Certified technician, 90-day warranty, same-day service.",
  localities: [
    'Vashi', 'Sanpada', 'Juinagar', 'Nerul', 'Seawoods',
    'CBD Belapur', 'Kharghar', 'Kalamboli', 'Panvel', 'New Panvel',
    'Airoli', 'Ghansoli', 'Rabale', 'Kopar Khairane', 'Turbhe',
  ],
  zones: [
    {
      name: 'Vashi & Sanpada',
      line: 'Harbour Line',
      station: 'Vashi Station / Sanpada Station',
      localities: ['Vashi', 'Sanpada', 'Sector 1–30 Vashi', 'Vashi Plaza', 'Inorbit Mall Vashi', 'Juinagar'],
      desc: "Vashi is Navi Mumbai's commercial hub. Our technicians cover all sectors, office buildings near Inorbit, and residential colonies.",
    },
    {
      name: 'Nerul & Seawoods',
      line: 'Harbour Line',
      station: 'Nerul Station / Seawoods Station',
      localities: ['Nerul', 'Seawoods', 'Seawoods Grand Central', 'Sector 1–50 Nerul', 'Palm Beach Road'],
      desc: 'Nerul and Seawoods are premium zones of Navi Mumbai. We cover all sectors including Palm Beach Road and Seawoods Grand Central area.',
    },
    {
      name: 'CBD Belapur & Kharghar',
      line: 'Harbour Line',
      station: 'CBD Belapur Station / Kharghar Station',
      localities: ['CBD Belapur', 'Belapur Sector 1–15', 'Kharghar', 'Kharghar Sector 1–35', 'Kharghar Hills', 'Central Park Kharghar'],
      desc: 'Belapur and Kharghar are booming residential and IT zones. Our technicians cover all sectors and gated townships.',
    },
    {
      name: 'Panvel & Kalamboli',
      line: 'Harbour Line',
      station: 'Khandeshwar Station / Mansarovar Station / Panvel Station',
      localities: ['Panvel', 'New Panvel', 'Kalamboli', 'Roadpali', 'Old Panvel', 'CIDCO areas'],
      desc: "Panvel is the southern end of Mumbai's Harbour line. We cover New Panvel, Old Panvel, and Kalamboli with same-day service.",
    },
    {
      name: 'Airoli, Ghansoli & Turbhe',
      line: 'Harbour Line',
      station: 'Airoli Station / Ghansoli Station / Turbhe Station',
      localities: ['Airoli', 'Ghansoli', 'Kopar Khairane', 'Rabale', 'Turbhe', 'TTC MIDC', 'Mahape'],
      desc: 'The northern Harbour line corridor covering IT parks and residential zones of Airoli, Ghansoli, and Turbhe.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Navi Mumbai | Doorstep Phone Repair | minto',
    description:
      'Doorstep mobile repair in Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli & all Navi Mumbai. Screen replacement, battery repair. Certified technicians, 90-day warranty. Book now!',
    keywords:
      'mobile repair Navi Mumbai, phone repair Navi Mumbai, screen repair Navi Mumbai, battery replacement Navi Mumbai, iPhone repair Navi Mumbai, Samsung repair Navi Mumbai, mobile repair Vashi, phone repair Nerul, Belapur mobile repair, Kharghar phone repair, Panvel mobile repair, Airoli phone repair, doorstep repair Navi Mumbai',
  },
  faqs: [
    {
      q: 'Do you offer doorstep mobile repair in Vashi?',
      a: 'Yes, we cover all Vashi sectors and commercial areas. Our technician reaches most Vashi locations within 60–90 minutes.',
    },
    {
      q: 'Can you repair my phone in Kharghar or Belapur?',
      a: 'Yes, Kharghar and CBD Belapur are fully covered including all sectors and the IT park zones.',
    },
    {
      q: 'Do you also cover Panvel and New Panvel?',
      a: 'Yes, Panvel and New Panvel are part of our Navi Mumbai service zone via the Harbour line.',
    },
    {
      q: 'How much does screen replacement cost in Navi Mumbai?',
      a: 'Screen replacement starts from ₹999 depending on your device. Select your phone on the booking page for the exact price.',
    },
    {
      q: 'Do you cover the IT parks in Airoli and Ghansoli?',
      a: 'Yes, TTC MIDC, Rabale, and all IT parks in Airoli and Ghansoli are covered. We visit offices and service your phone at your desk.',
    },
  ],
};

const NaviMumbaiPage: React.FC = () => <AreaLandingPage area={naviMumbai} />;
export default NaviMumbaiPage;
